angular.module('gym.data_series').factory('DataSeries', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('data_series');
}]);
